import axios from 'axios'
import config from '@assets/config.json' // api 请求json

const state = {}
const mutations = {}
const getters = {}
const actions = {
  // 拉取展区数据
  getExhibitionArea({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${
            config.api.reqApi
          }/api/ThirdPartyInfo/getExhibitionArea?exhibitionId=${
            opt.exhibitionId
          }`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 查询所有展区
  getAllArea({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ThirdPartyInfo/getAllArea?exhibitionId=${
            opt.exhibitionId
          }`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getAllArea1({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ThirdPartyInfo/getAllArea?exhibitionId=${
            opt.exhibitionId
          }&isEnable=true`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 批量修改语言类别
  areaLanguageSetting({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/areaLanguageSetting`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 修改展区启用状态
  areaIsEnable({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/areaIsEnable`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 拉取第三方商品
  getExhibitionCommodity({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${
            config.api.reqApi
          }/api/ThirdPartyInfo/getExhibitionCommodity?exhibitionId=${
            opt.exhibitionId
          }`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 批量设置报名类别
  batchSettleReportType({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/batchSettleReportType`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 批量修改分组设置
  batchSettleGroup({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/batchSettleGroup`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 批量修改展团设置
  batchSettleIntermediator({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/batchSettleIntermediator`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 分组添加
  addGroup({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/addGroup`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  //删除分组
  deleteGroup({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ThirdPartyInfo/deleteGroup?Id=${opt.id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 修改分组
  updateGroup({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/updateGroup`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 修改商品分组启用状态
  groupIsEnable({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/groupIsEnable`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 修改商品启用状态
  commodityIsEnable({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/commodityIsEnable`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 查询所有商品类别
  getExhibitionCommodityKind({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${
            config.api.reqApi
          }/api/ThirdPartyInfo/getExhibitionCommodityKind?exhibitionId=${
            opt.exhibitionId
          }`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 查询所有商品分组
  getExhibitionCommodityGroup({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${
            config.api.reqApi
          }/api/ThirdPartyInfo/getExhibitionCommodityGroup?exhibitionId=${
            opt.exhibitionId
          }`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 获取商品信息
  getCommodities({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ThirdPartyInfo/getCommodities`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
